import React from 'react';

import { useCustomTheme } from '../../../hooks/useCustomTheme';

export function HorizontalProgressBar({
  progressValue,
  color,
  bgColor,
  variant = 'medium',
  style = {},
}: {
  progressValue: number | null;
  color?: string;
  bgColor?: string;
  variant?: 'small' | 'medium';
  style?: React.CSSProperties;
}) {
  const { palette, customBorderRadius } = useCustomTheme();

  const barSizesByVariant = {
    small: {
      width: '100%',
      height: 4,
    },
    medium: {
      width: '100%',
      height: 8,
    },
  };

  const barHeight = barSizesByVariant[variant].height;
  const barWidth = barSizesByVariant[variant].width;
  const progressColor = color ?? palette.primary.main;
  const progressPosition = progressValue === 0 ? `${100 - barHeight / 2}%` : `${100 - (progressValue ?? 0)}%`;

  return (
    <div
      style={{
        height: barHeight,
        width: barWidth,
        backgroundColor: bgColor || palette.grey[200],
        borderRadius: customBorderRadius.paper,
        overflow: 'hidden',
        display: 'flex',
        position: 'relative',
        marginInline: variant === 'small' ? 1 : 0,
        marginBlock: variant === 'small' ? 6 : 12,
        transition: 'all ease',
        ...style,
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: barWidth,
          height: barHeight,
          right: progressPosition,
          backgroundColor: progressColor,
          borderRadius: customBorderRadius.paper,
          alignSelf: 'flex-end',
          opacity: progressValue === null ? 0 : 1,
          transition: 'all ease',
        }}
      ></div>
    </div>
  );
}
